import { AffineSchemas } from '@blocksuite/blocks/schemas';
import { AIChatBlockSchema } from '@blocksuite/presets';
import type { BlockSchemaType } from '@blocksuite/store';
import { Schema } from '@blocksuite/store';

export const globalBlockSuiteSchema = new Schema();

const baseSchemas: BlockSchemaType[] = [...AffineSchemas, AIChatBlockSchema];
globalBlockSuiteSchema.register(baseSchemas);

export function registerPiqueSchemas(schemas: BlockSchemaType[]) {
  globalBlockSuiteSchema.register(schemas);
}
